export enum TeamResourceViewModelType {
  Member = 'member',
  Group = 'group',
  Email = 'email'
}
